export default "__VITE_ASSET__3cd84769__"